import playerIdBreadcrumb from '../../components/Breadcrumb/breadcrumbFunctions/player/playerIdBreadcrumb'
import playerCreateBreadcrumb from '../../components/Breadcrumb/breadcrumbFunctions/player/playerCreateBreadcrumb'
import playerBreadcrumb from '../../components/Breadcrumb/breadcrumbFunctions/player/playerBreadcrumb'
import teamCalendarBreadcrumb from '../../components/Breadcrumb/breadcrumbFunctions/calendar/teamCalendarBreadcrumb'
import calendarBreadcrumb from '../../components/Breadcrumb/breadcrumbFunctions/calendar/calendarBreadcrumb'
import calendarIdBreadcrumb from '../../components/Breadcrumb/breadcrumbFunctions/calendar/calendarIdBreadcrumb'
import teamCalendarIdBreadcrumb from '../../components/Breadcrumb/breadcrumbFunctions/calendar/teamCalendarIdBreadcrumb'
import playerStatsBreadcrumb from '../../components/Breadcrumb/breadcrumbFunctions/stats/playerStatsBreadcrumb'

const BREADCRUMB_ROUTES = [
  { path: '/calendar', breadcrumb: calendarBreadcrumb },
  { path: '/calendar/:eventId', breadcrumb: calendarIdBreadcrumb },

  { path: '/teamCalendar', breadcrumb: teamCalendarBreadcrumb },
  { path: '/teamCalendar/:eventId', breadcrumb: teamCalendarIdBreadcrumb },

  // Create should be above id
  { path: '/players', breadcrumb: playerBreadcrumb },
  { path: '/players/create', breadcrumb: playerCreateBreadcrumb },
  { path: '/players/:playerId', breadcrumb: playerIdBreadcrumb },

  { path: '/profile', breadcrumb: () => ['PROFILE'] },

  { path: '/orgSettings', breadcrumb: () => ['ORGANISATION SETTINGS'] },
  { path: '/subscription', breadcrumb: () => ['BILLING'] },

  { path: '/teamSettings', breadcrumb: () => ['TEAM SETTINGS'] },
  { path: '/game/stats', breadcrumb: () => ['GAME STATISTICS'] },

  { path: '/stats/player/:playerId', breadcrumb: playerStatsBreadcrumb },
]

export default BREADCRUMB_ROUTES
